require('./lib/modernizr.js');
import 'promise-polyfill/src/polyfill';

global._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

global.$ = global.jQuery = require('jquery');

// Manages Swipe events
require('hammerjs');

require('bootstrap-sass');
require('bootstrap');

// Simple Bootstrap modals
global.bootbox = require('bootbox');

require('jquery-lazyload');
require('select2');
global.lightbox = require('lightbox2');

global.Chart = require('chart.js');

global.moment = require('moment');

global.Vue = require('vue');
global.Vuex = require('vuex');

Vue.use(Vuex);

import VeeValidate, { Validator } from 'vee-validate';
import fr from 'vee-validate/dist/locale/fr';

Validator.localize('fr', fr);

Vue.use(VeeValidate, {
    locale: 'fr',
    events: 'blur'
});

global.VeeValidate = VeeValidate;